<template>
  <div>
    <!-- Common Component -->
    <b-container fluid>
     <PropertyBase
        :object="object"
        :isNew="isNew"
        :payloads="basicItems"
        @input="reflectBasicItem"
      />
      <!-- DataLength -->
      <b-form-group
        label-cols="3"
        label="データ長"
        label-for="data_length"
        label-align="left"
        required>
        <b-form-input
          id="data_length"
          v-model="basicItems.property_size"
          :state="numValidator"
        ></b-form-input>
        <b-form-invalid-feedback class="text-left" :state="numValidator">
          整数を入力してください
        </b-form-invalid-feedback>
      </b-form-group>
      <!-- Common Component -->
      <b-row align-h="center">
        <template >
          <button type="button" class="btn btn-info button_spacer" v-if="isNew" @click="createProperty">作成</button>
          <button type="button" class="btn btn-info button_spacer" @click="updateProperty" v-else>変更</button>
        </template>
        <button
          @click="displayResumeModal = !displayResumeModal"
          class="btn btn-outline-secondary"
        >戻る</button>
      </b-row>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？？</p>
        </b-row>
        <b-row align-h="around">
          <button
            class="btn btn-outline-secondary"
            @click="pageBack"
          >はい</button>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-container>
  </div>
</template>
<script>
import PropertyBase from '../../common_parts/PropertyBase.vue'
import { API, graphqlOperation } from 'aws-amplify'
import { mapState } from 'vuex'
export default {
  name: 'Property',
  components: {
    PropertyBase
  },
  data () {
    return {
      object: '',
      isNew: '',
      id: '',
      displayResumeModal: false,
      basicItems: {
        no: '',
        name: '',
        version: '',
        description: '',
        property_size: ''
      },
      toast: {}
    }
  },
  computed: {
    numValidator () {
      return !!Number(parseInt(this.basicItems.property_size))
    },
    ...mapState(['version'])
  },
  async created () {
    this.object = this.$route.path.split('/')[1]
    // to change the attribute of route params
    this.id = this.$route.params.propertyId
    if (this.id) {
      this.isNew = false
      const properties = await API.graphql(graphqlOperation(`
        query getProperty {
          getProperty(no: ${this.id}, version: "${this.version}"){
            no
            name
            version
            description
            property_size
          }
        }
      `))
      // to check query result
      if (properties.data.getProperty) {
        this.basicItems = { ...properties.data.getProperty }
      } else {
        this.$router.push('/' + this.object)
      }
    } else {
      this.isNew = true
      this.id = this.$route.query.parent
    }
  },
  methods: {
    reflectBasicItem (event) {
      this.basicItems = { ...event }
    },
    makeToast (title, message, variant = 'default') {
      this.$bvToast.toast(message, {
        title: title,
        variant: variant,
        solid: true
      })
    },
    reflectDataLength (value) {
      this.basicItems.property_size = parseInt(value)
    },
    async updateProperty () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}`
        requestBody += this.version === '' ? '' : `version: "${this.version}"`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"`
        requestBody += this.basicItems.description === '' ? '' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"`
        requestBody += this.basicItems.property_size === '' ? '' : `property_size: ${this.basicItems.property_size}`
        const request = `mutation updateProperty {
          updateProperty(input:{
            ${requestBody}
          }){
            no
            version
            name
            description
          }
        }`
        this.$log.debug('=====Property Update Input=====', request)
        const response = await API.graphql(graphqlOperation(request))
        this.makeToast('正常終了', `${this.translate[this.object]}更新が完了しました。`, 'info')
        this.$log.debug('=====Property Update Success=====', response)
        this.$router.go()
      } catch (e) {
        this.makeToast('エラー', `${this.translate[this.object]}更新中にエラーが発生しました。`, 'danger')
        this.$log.debug('=====Property Update Error=====', e)
      }
    },
    async createProperty () {
      try {
        let requestBody = ''
        requestBody += this.basicItems.no === '' ? '' : `no: ${this.basicItems.no}\n`
        requestBody += this.version === '' ? '' : `version: "${this.version}"\n`
        requestBody += this.basicItems.name === '' ? '' : `name: "${this.basicItems.name}"\n`
        requestBody += this.basicItems.description === '' ? '' : `description: "${this.basicItems.description.replace(/\r?\n/g, '\\n')}"\n`
        requestBody += this.basicItems.property_size === '' ? '' : `property_size: ${this.basicItems.property_size}\n`
        const response = await API.graphql(graphqlOperation(`mutation createProperty {
          createProperty(input:{
            ${requestBody}
          }){
            no
            version
            name
            description
          }
        }`))
        this.makeToast('正常終了', `${this.translate[this.object]}作成が完了しました。`, 'info')
        this.$log.debug('=====Property Create=====', response)
        await this.$router.push(`/property/${response.data.createProperty.no}`)
        this.$router.go()
      } catch (e) {
        this.$log.debug('=====Property Create Error=====', e)
        const isConditionalError = e.errors.some(
          function (elm) {
            return elm.message.includes('ConditionalCheckFailedException')
          }
        )
        if (isConditionalError) {
          this.makeToast('失敗', `作成に失敗しました。\nNoが重複していないかご確認ください。`, 'danger')
        } else {
          this.makeToast('失敗', '作成に失敗しました。\n必須項目の入力漏れがないかご確認ください。', 'danger')
        }
      }
    },
    pageBack () {
      this.$router.go(-1)
    }
  }
}
</script>
